import React, { useContext } from 'react'
import { StyledStaticPageContainer } from '../components/StyledStaticPageContainer'
import { StyledUpLateButton } from '../components/StyledUpLateButton'
import { StyledWardenParagraph } from '../components/StyledWardenParagraph'
import { StyledWardenTitle } from '../components/StyledWardenTitle'
import { useLocation } from 'react-router'
import { TNToastComponent } from '../../../content/TNToastNotification/TNToastNotification'
import { useOriginUrl } from '../helpers/origin-url-helper'
import { ConfigurationContext } from '@news-mono/web-common'

export const EmailVerified = () => {
    const originUrl = useOriginUrl()
    const config = useContext(ConfigurationContext)
    const homepageUrl = config.publicUrl

    // Return the user to the article they were reading
    const onContinueReading = () => {
        window.location.assign(originUrl)
    }
    // Return the user to the homepage, used on the error pages
    const onReturnHome = () => {
        window.location.assign(homepageUrl)
    }

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const successful = queryParams.get('success')
    const code = queryParams.get('code')
    const componentProps: ComponentProps = {
        onContinueReading: onContinueReading,
        onReturnHome: onReturnHome,
    }

    const Component =
        queryParams.has('success') && successful === 'false' // Query parameters equal to the already verified state
            ? AlreadyVerifiedStateComponent
            : code === 'success' && successful === 'true' // Query parameters equal successful verification
            ? VerifiedStateComponent
            : InvalidStateComponent // Otherwise, it's an invalid state component

    return Component(componentProps)
}

interface ComponentProps {
    onContinueReading: () => void
    onReturnHome: () => void
}

const AlreadyVerifiedStateComponent = (props: ComponentProps) => (
    <>
        <TNToastComponent
            type={'error'}
            text={'Something went wrong.'}
            useMaxWidth={false}
            forceMaxWidth={true}
        />

        <StyledStaticPageContainer>
            <StyledWardenTitle>You are already verified.</StyledWardenTitle>
            <StyledWardenParagraph>
                Your email address has already been verified.
                <br />
                <br />
                You have full access to all features including comments and
                puzzles.
            </StyledWardenParagraph>
            <StyledUpLateButton onClick={props.onContinueReading}>
                Continue Reading
            </StyledUpLateButton>
        </StyledStaticPageContainer>
    </>
)

const VerifiedStateComponent = (props: ComponentProps) => (
    <>
        <TNToastComponent
            type={'success'}
            text={'Your email has been verified.'}
            useMaxWidth={false}
        />

        <StyledStaticPageContainer>
            <StyledWardenTitle>You're all set!</StyledWardenTitle>
            <StyledWardenParagraph>
                Thank you for verifying your email.
                <br />
                <br />
                You can now log in to access all features including comments and
                puzzles.
            </StyledWardenParagraph>
            <StyledUpLateButton onClick={props.onContinueReading}>
                Continue Reading
            </StyledUpLateButton>
        </StyledStaticPageContainer>
    </>
)

const InvalidStateComponent = (props: ComponentProps) => (
    <>
        <TNToastComponent
            type={'error'}
            text={'Invalid email verification.'}
            useMaxWidth={false}
            forceMaxWidth={true}
        />

        <StyledStaticPageContainer>
            <StyledWardenTitle>Something went wrong.</StyledWardenTitle>
            <StyledWardenParagraph>
                If you think this is incorrect please report this to the support
                team.
            </StyledWardenParagraph>
            <StyledUpLateButton onClick={props.onReturnHome}>
                Back to Home
            </StyledUpLateButton>
        </StyledStaticPageContainer>
    </>
)
